/* eslint-disable react/require-default-props */

import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';
import StyledDesktopNavLink from 'components/appbar/desktop/StyledDesktopNavLink';
import StyledMobileNavLink from 'components/appbar/mobile/StyledMobileNavLink';
import { selectLocale } from 'models/localization';
import { DEFAULT_THEME_COLOR } from 'appenv';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import { useMediaQuery } from '@material-ui/core';
import { matchPath } from 'react-router-dom';
import { CustomPage } from 'models/types/customPage';

declare global {
  interface Window {
    trackingEventToFirebase: (userSession: any, eventType: string, eventName: string, eventInfo: string | number) => any;
    trackingEventToFirebaseWithoutLogin: (eventType: string, eventName: string, eventInfo: string | number) => any;
    trackingItemToFirebase: (userSession: any, eventType: string, eventSubType: string, eventName: string, eventInfo: string | number, boothId: string | number, boothName: string) => any;
  }
}

interface CustomPageLinkProps extends CustomPage {
  onClick?: () => any;
  preventDefaultTracking?: boolean;
}

const CustomPageLink = ({
  name,
  pageTitle,
  buttonName,
  path,
  action,
  src,
  kind,
  customHtml,
  onClick,
  preventDefaultTracking,
}: CustomPageLinkProps) => {
  const locale = useSelector(selectLocale);
  const {
    themeColor,
  } = useSelector((state) => state.eventConfigs);

  const activeLinkStyle = {
    color: themeColor || DEFAULT_THEME_COLOR,
  };

  const isDesktop = useMediaQuery('(min-width: 960px)');
  const deviceName = isDesktop ? 'desktop' : 'mobile';
  const NavLinkComponent = isDesktop ? StyledDesktopNavLink : StyledMobileNavLink;
  const deviceAction = action[deviceName] ?? action.desktop ?? action.mobile;
  const newTabHref = kind === 'WEBSITE' ? findAvailableLocale(src, locale) : undefined;

  const handleClick = (key: string) => {
    if (!preventDefaultTracking) {
      window.trackingEventToFirebase(null, 'MainMenu_Click', 'CustomPage', key);
    }
    onClick?.call(null);
    if (kind === 'HTML' && deviceAction === 'NEWTAB') {
      const tab = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
      tab.document.write(findAvailableLocale(customHtml, locale));
      tab.document.close();
    }
  };

  switch (deviceAction) {
    case 'INLINE':
      return (
        <NavLinkComponent
          key={name}
          href={newTabHref}
          to={findAvailableLocale(path, locale)}
          onClick={() => handleClick(name)}
          activeStyle={activeLinkStyle}
          isActive={(match, location) => !!(
            matchPath(location.pathname, {
              path: Object.values(path),
              exact: true,
            })
          )}
        >
          {ReactHtmlParser(findAvailableLocale(buttonName || pageTitle, locale))}
        </NavLinkComponent>
      );
    case 'NEWTAB':
      return (
        <NavLinkComponent
          as="a"
          key={name}
          href={newTabHref}
          target="_blank"
          onClick={() => handleClick(name)}
        >
          {ReactHtmlParser(findAvailableLocale(buttonName || pageTitle, locale))}
        </NavLinkComponent>
      );
    default:
      return null;
  }
};

export default CustomPageLink;
